import { Option } from "../../../Admin/Types/AdminType";

// Add "V = string" to the generic parameters
export const mapToOptions = <T extends string | number | object, V = string>(
  data: T[],
  labelKey?: keyof T,
  valueKey?: keyof T
): Option<V>[] => { // <--- Change this to V
  if (!data) return [];

  return data.map((item) => {
    if (typeof item === "string" || typeof item === "number") {
      return {
        label: String(item),
        value: item as unknown as V, // Cast to V
      };
    }

    return {
      label: labelKey ? String(item[labelKey]) : "Unknown",
      value: valueKey ? (item[valueKey] as unknown as V) : ("Unknown" as unknown as V),
    };
  });
};